import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncateWithEllipsis'
})
export class TruncateWithEllipsisPipe implements PipeTransform {

    transform(value: string | number, limit: number): string {
        const stringValue = String(value);
        return stringValue && stringValue.length > limit ? stringValue.substring(0, limit) + '...' : stringValue;
    }
}
